<template>
  <v-container>
    <h1>Order Reset</h1>

    <v-card>
      <v-card-title>Orden Actual:
        <span v-if="$store.getters.orderSystem.order && $store.getters.orderSystem.order.identifier">{{$store.getters.orderSystem.order.identifier}}</span>
        <span v-else-if="$store.getters.orderSystem.order" class="ml-1"> Borrador</span>
      </v-card-title>

      <v-card-text>
        {{$store.getters.orderSystem.order}}
      </v-card-text>
    </v-card>
    <v-divider class="my-3"></v-divider>
    <v-btn
        @click="$store.commit('clearOrder')"
    >
      Reiniciar orden
    </v-btn>

  </v-container>
</template>

<script>
export default {
  name: "OrderResetPage"
}
</script>

<style scoped>

</style>
